// const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
import { PhoneNumberUtil } from 'google-libphonenumber';
// import parse from 'libphonenumber-js';

export default function (payload) {
  return PhoneNumberUtil.getInstance().parse(payload);
}
